import { render, staticRenderFns } from "./manageDw.vue?vue&type=template&id=d979afe2&"
import script from "./manageDw.vue?vue&type=script&lang=js&"
export * from "./manageDw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports